import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { reducer as formReducer } from 'redux-form'
import { reducer as toastrReducer } from 'react-redux-toastr'

import { authReducer, authTypes } from 'features/auth'
import { articleReducer } from 'features/articles'
import { revisionReducer } from 'features/revisions'
import { settingsReducer } from 'features/settings'

const createAppReducer = history =>
	combineReducers({
		router: connectRouter(history),
		auth: authReducer,
		settings: settingsReducer,
		articles: articleReducer,
		revisions: revisionReducer,
		form: formReducer,
		toastr: toastrReducer,
	})

const createRootReducer = history => (state, action) => {
	if (action.type === authTypes.LOGOUT_SUCCESS) {
		state = undefined
	}

	return createAppReducer(history)(state, action)
}

export default createRootReducer
